export default __webpack_public_path__ + "static/media/6.2c895256.png";